/**
 * `ranked-shares` v1 — a few ranked lists of names with the share each one
 * holds, e.g. the hosts serving most detected IPs or domains.
 *
 * It is a display contract: the host's resolver turns the report's own shape
 * (provisional for IP blocking) into it, so a change of the report schema is
 * absorbed by the resolver. `share` is a fraction (`1` is 100 %) of the list's
 * `total`; the shares of one list never add up to more than 1.
 */
export const RANKED_SHARES_CONTRACT = { name: "ranked-shares", version: 1 } as const;

export interface RankedShareItem {
  label: string;
  share: number;
}

export interface RankedShareList {
  /** Stable key the widget's `listId` selects, e.g. `iptv`. */
  id: string;
  /** What the list covers, e.g. "IPTV". */
  label: string;
  /** What the shares are shares of, e.g. 1,135 unique IPs. */
  total?: { value: number; unit: string } | null;
  /** Largest first. */
  items: RankedShareItem[];
  coverage?: { attributed: number; unattributed: number };
}

export interface RankedSharesData {
  lists: RankedShareList[];
}
